export const IFRAME_MDX_DIRECTIVE_NAME = 'iframe';
